<template>
  <div class="page">
    <div class="page-padding">
      <figure class="visual">
        <picture>
          <source media="(min-width: 550px)" srcset="img/visual-bahnnostalgie.jpg">
          <img src="img/visual-bahnnostalgie-small.jpg"/>
        </picture>
        <figcaption>
          <h1>Bahnnostalgie</h1>
        </figcaption>
      </figure>
      <h2 class="carousel-headline">Unsere Filme zum Thema Bahnnostalgie</h2>
      <bahnnostalgie-movies-list></bahnnostalgie-movies-list>
    </div>
  </div>
</template>

<script>

import BahnnostalgieMoviesList from './BahnnostalgieMoviesList.vue';

export default {
  components: {
    bahnnostalgieMoviesList: BahnnostalgieMoviesList
  },
  beforeRouteEnter(to, from, next) {
    window.scrollToTop();
    next();
  },
}
</script>



// WEBPACK FOOTER //
// Bahnnostalgie.vue?0d99be72